import React from 'react';
import './Header.css';

const Header = () => (
  <header className="header">
    <h1>Cookies Pov</h1>
    <p>A lot of memories from the best pup 🐶</p>
  </header>
);

export default Header;
